import React from 'react'
import { Card, CardBody, Row, Col } from 'reactstrap';

function ProductCategories({products}) {
  
  const stats = [
    {
      title: "Total Products",
      count: products.totalProducts,
      color: "primary",
      icon: "bx-package"
    },
    {
      title: "Public Products",
      count: products.publicProducts,
      color: "success",
      icon: "bx-globe"
    },
    {
      title: "Addon Products",
      count: products.addonProducts,
      color: "warning",
      icon: "bx-plus-circle"
    }
  ];

  return (
    <>
    <Card>
      <CardBody>
        <h4 className="card-title mb-4">Product Categories</h4>
        <Row>
          {stats.map((stat, index) => (
            <Col md={4} key={index}>
              <div className={`text-center border-end border-light p-3 ${index === stats.length - 1 ? 'border-0' : ''}`}>
                <div className={`avatar-sm mx-auto mb-3 p-1 bg-${stat.color} bg-opacity-10 rounded-circle`}>
                  <span className={`avatar-title rounded-circle bg-${stat.color} bg-opacity-10 text-${stat.color}`}>
                    <i className={`bx ${stat.icon} font-size-24`}></i>
                  </span>
                </div>
                <h5 className="font-size-15 mb-1">{stat.count}</h5>
                <p className="text-muted mb-0">{stat.title}</p>
              </div>
            </Col>
          ))}
        </Row>
      </CardBody>
    </Card>
    {/* <Card>
      <hr className="my-4" />
        <h5 className="card-title mb-3">Venues</h5>
        <div className="text-center">
          <div className="avatar-sm mx-auto mb-3 p-1 bg-info bg-opacity-10 rounded-circle">
            <span className="avatar-title rounded-circle bg-info bg-opacity-10 text-info">
              <i className="bx bx-building-house font-size-24"></i>
            </span>
          </div>
          <h5 className="font-size-15 mb-1">{products.venues}</h5>
          <p className="text-muted mb-0">Total Venues</p>
        </div>
    </Card> */}
    </>
  )
}

export default ProductCategories
